import { render, staticRenderFns } from "./step-test-email.vue?vue&type=template&id=6435f604&scoped=true"
import script from "./step-test-email.vue?vue&type=script&lang=js"
export * from "./step-test-email.vue?vue&type=script&lang=js"
import style0 from "./step-test-email.vue?vue&type=style&index=0&id=6435f604&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6435f604",
  null
  
)

export default component.exports